import { render, staticRenderFns } from "./CommunicationLogModal.vue?vue&type=template&id=1be3b003&scoped=true&"
import script from "./CommunicationLogModal.vue?vue&type=script&lang=js&"
export * from "./CommunicationLogModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationLogModal.vue?vue&type=style&index=0&id=1be3b003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3b003",
  null
  
)

export default component.exports